'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { useEffect } from 'react';

export const LeadFeederScript = () => {
  const pathname = usePathname();

  useEffect(() => {
    const ldfdr =
      (window as any).ldfdr ||
      ((...rest: any[]) => {
        (window as any).ldfdr._q = (window as any).ldfdr._q ?? [];
        (window as any).ldfdr._q.push([].slice.call(rest));
      });

    (window as any).ldfdr = ldfdr;
  }, []);

  if (!pathname?.startsWith('/gewerbe/e-mobilitaet')) {
    return null;
  }

  return (
    <Script
      async
      data-usercentrics="Leadfeeder"
      defer
      id="leadfeeder-script-loader"
      src="https://sc.lfeeder.com/lftracker_v1_p1e024BkyAWaGB6d.js"
      type="text/plain"
    />
  );
};
